import React from "react";
import { useParams } from "react-router-dom";
import {categories}  from "./Categories"
import WeekOffer from "./WeekOffer";


const CategoryPage = () => {
  const { slug } = useParams();
  const category = categories[slug];

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      
      {/* <h2>{slug.toUpperCase()} Collection</h2> */}
      <h1>{category?.title}</h1>
      <img src={category?.banner} />
     
      {/* <p>Load products here based on this category.</p> */}
      <WeekOffer category={slug} />
    </div>
  );
};

export default CategoryPage;
